/**
 * Die nächste Zeile ruft den Wert des "data-env"-Attributs des "documentElement" des HTML-Dokuments ab.
 * Dieses Attribut gibt die aktuelle Umgebung an und sollte in der Live-Umgebung einen Wert von "live" haben.
 * Wenn die Umgebung "live" ist, wird das Fehlerobjekt als Warnung in die Konsole
 * protokolliert, indem die Methode "console.warn" verwendet wird.
 * Wenn die Umgebung nicht "live" ist, wird das Fehlerobjekt mit dem Schlüsselwort "throw" geworfen. Dadurch wird
 * der Fehler die Aufrufstapel hinaufpropagiert, bis er von einem geeigneten "catch"-Block abgefangen wird.
 *
 * Insgesamt soll dieser Code einen Mechanismus bereitstellen, um Fehler in verschiedenen Umgebungen
 * unterschiedlich zu behandeln, insbesondere um zu verhindern, dass Fehler in der Live-Umgebung geworfen
 * werden, wo sie Probleme für Benutzer verursachen könnten.
 */
export default class FxxlError extends Error {
    constructor(message) {
        super(message);
        this.name = FxxlError.name;
        this.env = document.documentElement.getAttribute('data-env');
        if (this.env === 'live') {
            console.warn(this);
        } else {
            console.error(this);
            throw this;
        }
    }
}